import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * Campo OT IDMH (orden de trabajo): solo dígitos, máximo 6 (ej. 260001).
 * El backend acepta hasta 10 dígitos; el límite de 6 es de negocio y se aplica aquí.
 * Las clases replican las de app-input-field para verse igual que los demás inputs.
 */
@Component({
    selector: 'app-ot-input',
    standalone: true,
    imports: [NgClass],
    template: `
        <div class="relative">
            <input type="text" inputmode="numeric" autocomplete="off"
                [value]="value" [disabled]="disabled" [attr.maxlength]="maxLength"
                [placeholder]="placeholder"
                (input)="onInput($event)"
                [ngClass]="inputClasses" />
        </div>
    `,
})
export class OtInputComponent {
    @Input() value = '';
    @Input() disabled = false;
    @Input() error = false;
    @Input() placeholder = 'Ej: 260001';
    @Input() maxLength = 6;
    @Output() valueChange = new EventEmitter<string>();

    get inputClasses(): string {
        let classes = 'h-11 w-full rounded-lg border appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-hidden focus:ring-3 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30';
        if (this.disabled) {
            classes += ' text-gray-500 border-gray-300 opacity-40 bg-gray-100 cursor-not-allowed dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700';
        } else if (this.error) {
            classes += ' border-error-500 focus:border-error-300 focus:ring-error-500/20 dark:text-error-400 dark:border-error-500 dark:focus:border-error-800';
        } else {
            classes += ' bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring-brand-500/20 dark:border-gray-700 dark:text-white/90 dark:focus:border-brand-800';
        }
        return classes;
    }

    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const clean = input.value.replace(/\D/g, '').slice(0, this.maxLength);
        if (clean !== input.value) input.value = clean;
        this.value = clean;
        this.valueChange.emit(clean);
    }
}
